<template>
    <div class="card-grid-legend d-flex align-center flex-wrap ga-4 pa-2 mb-3">
        <span class="legend-title font-weight-bold">Estado:</span>
        <div class="d-flex align-center ga-1"><span class="legend-color-dot" style="background-color: #00E676;"></span><span class="legend-text">OK (&le; 100 ms)</span></div>
        <div class="d-flex align-center ga-1"><span class="legend-color-dot" style="background-color: #FFEA00;"></span><span class="legend-text">Moderado (101 - 500 ms)</span></div>
        <div class="d-flex align-center ga-1"><span class="legend-color-dot" style="background-color: #FF3D00;"></span><span class="legend-text">Crítico (> 500 ms)</span></div>
        <div class="d-flex align-center ga-1"><span class="legend-color-dot" style="background-color: #9E9E9E;"></span><span class="legend-text">Desconectado (OFF)</span></div>
    </div>

    <div class="sections-container">
        <div v-for="group in filteredGroups" :key="group.subtipo" class="mb-4">
            <div class="d-flex align-center mb-2">
                <span class="text-subtitle-1 font-weight-bold text-white mr-2">{{ group.title }}</span>
                <v-chip size="x-small" color="grey-darken-2" variant="flat" class="px-1" style="height: 16px; font-size: 0.65rem;">
                    {{ group.items.length }}
                </v-chip>
            </div>

            <v-row v-if="group.items.length > 0" class="ma-0" dense>
                <v-col v-for="item in group.items" :key="item.ip" cols="12" sm="4" md="3" lg="2" xl="1"  class="pa-1" style="min-width: 12.5%;">
                    <div class="card-device-ultracompact pa-1 px-2" @click="$emit('select-device', item)">
                        <div class="d-flex justify-space-between align-start mb-1 ga-1">
                            <div class="d-flex flex-column text-truncate" style="max-width: 65%;">
                                <span class="device-name font-weight-bold text-truncate text-white" :title="item.name">{{ item.name }}</span>
                                <span class="device-model text-truncate" :class="getDeviceModel(item.anotacion) === 'S/M' ? 'text-grey-darken-1' : 'text-primary-lighten-2'">
                                    {{ getDeviceModel(item.anotacion) }}
                                </span>
                            </div>

                            <span class="latency-badge font-weight-bold" :style="{ color: getLatencyColor(item.latencia), borderColor: getLatencyColor(item.latencia) }">
                                {{ item.latencia < 0 ? 'OFF' : `${item.latencia}ms` }}
                            </span>
                        </div>

                        <div class="operability-bar-wrapper mb-1">
                            <div class="operability-stacked-bar">
                                <div class="bar-segment" style="background-color: #00E676;" :style="{ width: getOperabilityPercentages(item.ip).ok + '%' }" :title="`Excelente estado: ${getOperabilityPercentages(item.ip).ok.toFixed(1)}%`"></div>
                                <div class="bar-segment" style="background-color: #FFEA00;" :style="{ width: getOperabilityPercentages(item.ip).alert + '%' }" :title="`Alerta leve: ${getOperabilityPercentages(item.ip).alert.toFixed(1)}%`"></div>
                                <div class="bar-segment" style="background-color: #FF3D00;" :style="{ width: getOperabilityPercentages(item.ip).alarm + '%' }" :title="`Alarma crítica: ${getOperabilityPercentages(item.ip).alarm.toFixed(1)}%`"></div>
                                <div class="bar-segment" style="background-color: #9E9E9E;" :style="{ width: getOperabilityPercentages(item.ip).down + '%' }" :title="`Fuera de servicio: ${getOperabilityPercentages(item.ip).down.toFixed(1)}%`"></div>
                            </div>
                        </div>

                        <div class="d-flex justify-space-between align-center" style="font-size: 0.60rem !important;">
                            <span class="ip-text">{{ item.ip }}</span>
                            <span>Upd: {{ formatShortDate(item.fecha) }}</span>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script setup lang="ts">
import { LATENCY } from '@/interfaces/SmartLink/Topology';
import { getDeviceModel } from '@/utils/SmartLink/device';

defineProps<{
    filteredGroups: any[];
    getLatencyColor: (lat: number) => string;
    getOperabilityPercentages: (ip: string) => any;
    formatShortDate: (date?: string) => string;
}>();

defineEmits<{
    (e: 'select-device', item: LATENCY): void;
}>();
</script>